'use client'

import { useCallback, useState, type JSX } from 'react'

import dynamic from 'next/dynamic'

import { BlogPost, CarouselBreakPoint } from '@types'

import PostCard from '@components/post-card'
import useAddEventListener from '@hooks/useAddEventListener'
import useIsomorphicEffect from '@hooks/useClientSideLayoutEffect'

const Glider = dynamic(() => import('react-glider'))

export type CarouselProps = {
  posts: BlogPost[]
}

export default function Carousel({ posts = [] }: CarouselProps): JSX.Element {
  const [mobile, setMobile] = useState<boolean>(true)

  const handleResize = useCallback((): void => {
    const width = window.innerWidth
    if (width < 816) {
      setMobile(true)
    } else {
      setMobile(false)
    }
  }, [])

  useIsomorphicEffect(() => {
    handleResize()
  }, [handleResize])

  useAddEventListener('resize', handleResize)

  const responsive: CarouselBreakPoint[] = [
    {
      breakpoint: 1,
      settings: { slidesToShow: 1, slidesToScroll: 'auto' },
    },
    {
      breakpoint: 562,
      settings: { slidesToShow: 2, slidesToScroll: 'auto' },
    },
    {
      breakpoint: 816,
      settings: { slidesToShow: 3, slidesToScroll: 'auto' },
    },
  ]

  return (
    <Glider
      draggable={mobile}
      id="info"
      hasDots={mobile}
      duration={1.5}
      responsive={responsive}
      resizeLock
      scrollLock={!mobile}
    >
      {posts.map((el) => (
        <PostCard key={el.id} post={el} />
      ))}
    </Glider>
  )
}
